// Styles here will override Bulma styles
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const styledHeadline = css`
  font-family: 'WorkSans-Bold', Arial, Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 36px !important;
  line-height: 45px !important;
  color: #031b4e !important;
  margin-top: 0;
  margin-bottom: 10px;
  letter-spacing: 0px;

  &.featured {
    margin-bottom: 16px;
  }

  &.bloglist {
    font-size: 24px !important;
    line-height: 30px !important;
    letter-spacing: 0.25px;

    ${media('<desktop')} {
      font-size: 16px !important;
      line-height: 21px !important;
    }
  }
`;
